<div class="one-dialog">
    <div class="dialog-header d-flex">
        <div class="title flex-grow-1">
            <h2 mat-dialog-title>Cài đặt nhóm chuyển tiếp</h2>
        </div>
        <div class="right">
            <button mat-icon-button mat-dialog-close aria-label="Close dialog icon">
                <mat-icon>close</mat-icon>
            </button>
        </div>
    </div>
    <mat-dialog-content>
        <div class="dialog-body">
            <div class="row">
                <mat-form-field class="full" appearance="fill">
                    <mat-label>Nhóm chuyển tiếp</mat-label>
                    <input matInput disabled placeholder="Nhóm chuyển tiếp" [value]="group.targetName">
                </mat-form-field>
            </div>
            <div class="row">
                <mat-form-field class="full" appearance="fill">
                    <mat-label>Đề xuất có thể chuyển tiếp khi</mat-label>
                    <mat-select [formControl]="statusForm">
                        <mat-option [value]="forwardType" *ngFor="let forwardType of forwardWhens">
                            {{ forwardType }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </div>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
        <button mat-button mat-dialog-close>Hủy bỏ</button>
        <button mat-raised-button color="warn" (click)="onSave()">Lưu</button>
    </mat-dialog-actions>
</div>